import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const User = z.object({
  id: z.string(),
  givenName: z.string(),
  surname: z.string(),
  email: z.string(),
  role: z.number()
});

export default c.router({
  getUser: {
    method: 'GET',
    path: '/users/:id',
    responses: {
      200: User
    }
  }
});
